"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JSchema_1 = require("./JSchema");
var schemaMethods_1 = require("./schemaMethods");
var fmoney_1 = require("./methods/fmoney");
var mround_1 = require("./methods/mround");
var fnumber_1 = require("./methods/fnumber");
// import { string } from 'prop-types';
// @ts-ignore
// import AsyncComputed from 'vue-async-computed';
// import { useImperativeMethods } from 'react';
exports.validationMessages = {
    type: 'Nieprawidłowa wartość',
    integer: 'Pole musi być liczbą',
    required: 'Pole jest wymagane',
    minimum: 'Minimalnie {{minimum}}',
    maximum: 'Maksymalnie {{maximum}}',
    exclusiveMinimum: 'Musi być większe niz {{minimum}}',
    exclusiveMaximum: 'Musi być mniejsze niz {{maximum}}',
    multipleOf: 'Musi być wielokrotnością {{multipleOf}}',
    maxLength: 'Tekst jest zbyt długi, maksymalnie {{maxLength}} znaków',
    minLength: 'Tekst jest zbyt krótki, minimalnie {{minLength}} znaków',
    maxItems: 'Zbyt dużo elementów, maksymalnie {{maxItems}}',
    minItems: 'Za mało elementów, minimalnie {{minItems}}',
    enum: 'Nieprawidłowa wartość',
    pattern: 'Nieprawidłowy format'
};
var msgRegex = {
    minimum: /\{\{minimum\}\}/g,
    maximum: /\{\{maximum\}\}/g,
    exclusiveMaximum: /\{\{exclusiveMaximum\}\}/g,
    exclusiveMinimum: /\{\{exclusiveMinimum\}\}/g,
    multipleOf: /\{\{multipleOf\}\}/g,
    maxLength: /\{\{maxLength\}\}/g,
    minLength: /\{\{minLength\}\}/g,
    maxItems: /\{\{maxItems\}\}/g,
    pattern: /\{\{pattern\}\}/g,
    format: /\{\{format\}\}/g,
    enum: /\{\{enum\}\}/g,
    title: /\{\{title\}\}/g,
    value: /\{\{value\}\}/g
};
function getRuleMessage(schema, rule, value, $schema) {
    // let result = rules[rule];
    // if (result) return result;
    if ($schema === void 0) { $schema = null; }
    $schema = $schema || schema;
    var msg = schema.validationMessages[rule];
    if (msg === undefined) {
        if (rule === 'type') {
            msg = exports.validationMessages[schema.type];
        }
        if (msg === undefined) {
            msg = exports.validationMessages[rule] || rule;
        }
        // jeśli na starcie było zdefiniowane jako numer to od razu podmień
        if (typeof schema[rule] === 'number') {
            // msg = msg.replace(new RegExp(`{{${rule}}}`, 'g'), schema[rule]);
            msg = msg.replace(msgRegex[rule] || 'rrr', function () { return (schema[rule] === undefined ? '' : schema[rule]); });
        }
        schema.validationMessages[rule] = msg;
    }
    // return msg || rule;
    // zamiana {{maxLength}} na prawdziwą wartość
    msg = msg.replace(msgRegex[rule] || 'rrr', function () { return ($schema[rule] === undefined ? '' : $schema[rule]); });
    /*
  
    msg = msg
      .replace(/\{\{title\}\}/g, $schema.title || '')
      .replace(/\{\{minimum\}\}/g, $schema.minimum === undefined ? '' : $schema.minimum)
      .replace(/\{\{maximum\}\}/g, $schema.maximum === undefined ? '' : $schema.maximum)
      .replace(/\{\{exclusiveMaximum\}\}/g, $schema.exclusiveMaximum === undefined ? '' : $schema.exclusiveMaximum)
      .replace(/\{\{exclusiveMinimum\}\}/g, $schema.exclusiveMinimum === undefined ? '' : $schema.exclusiveMinimum)
      .replace(/\{\{multipleOf\}\}/g, $schema.multipleOf === undefined ? '' : $schema.multipleOf)
      .replace(/\{\{maxLength\}\}/g, $schema.maxLength === undefined ? '' : $schema.maxLength)
      .replace(/\{\{minLength\}\}/g, $schema.minLength === undefined ? '' : $schema.minLength)
      .replace(/\{\{maxItems\}\}/g, $schema.maxItems === undefined ? '' : $schema.maxItems)
      .replace(/\{\{minItems\}\}/g, $schema.minItems === undefined ? '' : $schema.minItems)
      .replace(/\{\{pattern\}\}/g, $schema.pattern || '');
  
    return msg.replace(/\{\{value\}\}/g, value);
  
    */
    return msg.replace(msgRegex.value, value);
    /*
      return {
          rule: rule,
          message: msg.replace(/\{\{value\}\}/g, value)
  
      }
      return rules[rule] = result;
      */
}
function validate(obj, value) {
    // let stime = (new Date()).getTime();
    var funcs = JSchema_1.getValidations(obj.$schema, true);
    for (var _i = 0, funcs_1 = funcs; _i < funcs_1.length; _i++) {
        var func = funcs_1[_i];
        var result = func(value, obj);
        if (result) {
            return result;
        }
    }
    if (obj.$isFuncValid !== undefined) {
        return obj.$isFuncValid;
    }
    return null;
}
function anyCalc(schema) {
    if (schema.anyCalc !== undefined) {
        return schema.anyCalc;
    }
    if (schema.calc || schema.summary || schema.aggregate) {
        Object.defineProperty(schema, 'anyCalc', {
            value: true
        });
        return true;
    }
    else if (schema.properties) {
        for (var key in schema.properties) {
            if (schema.properties.hasOwnProperty(key)) {
                var isCalc = anyCalc(schema.properties[key]);
                if (isCalc) {
                    Object.defineProperty(schema, 'anyCalc', {
                        value: true
                    });
                    return true;
                }
            }
        }
    }
    else if (schema.items) {
        return anyCalc(schema.items);
    }
    Object.defineProperty(schema, 'anyCalc', {
        value: false
    });
    return false;
}
function path(obj) {
    var result = '';
    if (obj.$parent) {
        if (obj.$parent.$schema.type === 'array') {
            return obj.$parent.$path + '[' + obj.$key + ']';
        }
        var ppath = obj.$parent.$path;
        if (ppath) {
            return ppath + '.' + obj.$key;
        }
    }
    return obj.$key;
}
var SchemaWrapper = /** @class */ (function () {
    function SchemaWrapper(VueConstructor, options) {
        this.Vue = VueConstructor;
        while (this.Vue.super) {
            this.Vue = this.Vue.super;
        }
        if (this.Vue.Renderless) {
            this.Vue = this.Vue.Renderless;
        }
        this.vueInstances = [];
        this.external = null;
        // dirty
        if (options) {
            this.options = Object.assign({}, SchemaWrapper.defaultOptions, options);
        }
        else {
            this.options = SchemaWrapper.defaultOptions;
        }
        this.form = null;
        this.asyncArrays = false;
        this.arrayAsObject = false;
        this.asyncComputed = false;
        // this.methods = mathmethods;
    }
    /**
     * czyszczenie z instancji Vue
     */
    SchemaWrapper.prototype.clear = function () {
        for (var _i = 0, _a = this.vueInstances; _i < _a.length; _i++) {
            var vm = _a[_i];
            vm.$destroy();
        }
        this.vueInstances = [];
    };
    SchemaWrapper.prototype.runAsync = function (func) {
        if (this.asyncArrays) {
            setTimeout(func, 0);
        }
        else {
            func();
        }
    };
    SchemaWrapper.prototype.isSimpleField = function (field) {
        return typeof field === 'string' && /[\*\-\/\+\$\.\=\!\<\>]/.test(field);
        return (typeof field === 'string' &&
            field.indexOf('.') === -1 &&
            field.indexOf('+') === -1 &&
            field.indexOf('<') === -1 &&
            field.indexOf('>') === -1 &&
            field.indexOf('!') === -1 &&
            field.indexOf('=') === -1 &&
            field.indexOf('-') === -1 &&
            field.indexOf('*') === -1 &&
            field.indexOf('/') === -1);
    };
    /*
  
    public validCalcFunction(vv: string | any[], wrapWith: boolean = true): string {
      let s: string = '';
      let needdata: boolean = false;
      if (typeof vv === 'string') {
        if (vv.indexOf('$root') > -1) {
          needdata = true;
        }
        if (vv.indexOf('$parent') > -1) {
          needdata = true;
          vv = vv.replace(/\$parent\.\$parent\.\$parent\./g, '$parent3.');
          vv = vv.replace(/\$parent\.\$parent\./g, '$parent2.');
          vv = vv.replace(/\$parent\./g, '$parent.');
        }
        if (!wrapWith) {
          return vv;
        }
  
        if (needdata) {
          s = `with(this.$options.$ext) {with($model) {return (${vv})}};`;
        } else {
          s = `with(this.$options.$ext.$model) {return (${vv})};`;
        }
      } else if (Array.isArray(vv)) {
        for (let i = 0; i < vv.length; i++) {
          const item: any = vv[i];
          let ss = item.when || item.if || '';
          if (ss.indexOf('$root') > -1) {
            needdata = true;
          }
          if (ss.indexOf('$parent') > -1) {
            needdata = true;
            ss = ss.replace(/\$parent\.\$parent\.\$parent\./g, '$parent3.');
            ss = ss.replace(/\$parent\.\$parent\./g, '$parent2.');
            ss = ss.replace(/\$parent\./g, '$parent.');
          }
          let ss2 = item.value;
          if (ss2 === undefined) {
            ss2 = ss;
          } else {
            if (typeof ss2 === 'string') {
              if (ss2.indexOf('$root') > -1) {
                needdata = true;
              }
              if (ss2.indexOf('$parent') > -1) {
                needdata = true;
                ss2 = ss2.replace(/\$parent\.\$parent\.\$parent\./g, '$parent3.');
                ss2 = ss2.replace(/\$parent\.\$parent\./g, '$parent2.');
                ss2 = ss2.replace(/\$parent\./g, '$parent.');
              }
            }
          }
  
          s += `if (${ss}) return (${ss2});`;
        }
        // s = `with(this._data.$parentmodel) {${s}};`;
  
        if (needdata) {
          s = `with(this.$options.$ext) {with($model) {${s}return false;}};`;
        } else {
          s = `with(this.$options.$ext.$model) {${s}return false;};`;
        }
      }
      // if (needdata) {
      // s = `with(this._data) {${s}};`;
      // }
      console.log('validCalcFunction', s);
      return s;
    }
  
    */
    SchemaWrapper.prototype.wrapProperty = function (dest, parent, propName, schema) {
        // let propFunction = () =>{
        var _this = this;
        // console.log('wrapProperty', propName);
        var Vue = this.Vue;
        var vm = null;
        var focused = false;
        var typeok = true;
        var reactivedata = new Object();
        var obj = new Object();
        var root = obj;
        var self = this;
        var computed = {};
        // const computedOnly: boolean = schema.computed;
        var computedOnly = false;
        var asyncComputed = null;
        // const extraData: any = {};
        var watch = {};
        var calcargs = [];
        var formSection = '';
        var dirty = self.options.startDirty || schema.computed;
        var useComputedModel = false;
        // let methods: any = {};
        // computed.$valid = function () {
        // console.log("read computed $valid", this.validation.errors.length == 0);
        //    return this.validation.errors.length == 0;
        // }
        if (dest) {
            root = dest.$root;
            Object.defineProperty(obj, '$parent', {
                enumerable: false,
                get: function () {
                    return dest;
                }
            });
        }
        // przygotowanie danych pod wyliczenia zależne od innych pól
        if (!self.options.disableValidations) {
            reactivedata.error = null;
        }
        // fix schema
        if (schema.cache === undefined) {
            schema.cache = {};
            /*
            Object.defineProperty(schema, 'cache', {
              writable: true,
              value: {}
            });
            */
        }
        if (schema.validationMessages === undefined) {
            schema.validationMessages = {};
            /*
            Object.defineProperty(schema, 'validationMessages', {
              value: {}
            });
            */
        }
        // kopia
        var $schema = null;
        if (!self.options.disableValidations) {
            // kopia
            $schema = {
                type: schema.type,
                title: schema.title,
                description: schema.description,
                cache: schema.cache,
                validationMessages: schema.validationMessages
            };
            /*
            Object.defineProperty($schema, 'cache', {
              writable: true,
              value: schema.cache
            });
            */
            // schema.validationMessages = schema.validationMessages;
            /*
            Object.defineProperty($schema, 'validationMessages', {
              writable: true,
              value: schema.validationMessages
            });
            */
            if (schema.format) {
                /*
                Object.defineProperty($schema, 'format', {
                  writable: true,
                  enumerable: true,
                  value: schema.format
                });
                */
                $schema.format = schema.format;
            }
            if (schema.readOnly) {
                $schema.readOnly = true;
            }
        }
        else {
            // bez kopii
            $schema = schema;
        }
        // extraData.methods = this.methods;
        // reactivedata.$schema = $schema;
        // reactivedata.focused = false;
        // reactivedata.$parentmodel = parent;
        // reactivedata.$key = propName;
        var userData = null;
        var vmUserData = null;
        Object.defineProperties(obj, {
            $root: {
                enumerable: false,
                get: function () {
                    return root;
                }
            },
            $schema: {
                enumerable: true,
                get: function () {
                    return $schema;
                }
            },
            $model: computedOnly
                ? {
                    enumerable: false,
                    get: function () {
                        return vm.value;
                    },
                    set: function (newValue) {
                        vm.value = newValue;
                    }
                }
                : {
                    enumerable: true,
                    get: function () {
                        return parent[propName];
                    },
                    set: function (newValue) {
                        Vue.set(parent, propName, newValue);
                        // vm.$set(parent, propName, newValue);
                        // parent[propName] = newValue;
                    }
                },
            $key: {
                enumerable: true,
                get: function () {
                    return propName;
                    // return vm.$options.$ext.$key
                },
                set: function (newValue) {
                    // console.log(`$key(${newValue},${propName})`);
                    propName = newValue;
                    // vm.$options.$ext.$key = newValue;
                }
            },
            $data: {
                enumerable: false,
                get: function () {
                    if (vmUserData === null) {
                        /*
                        if (process.env.NODE_ENV === 'development') {
                          console.log('create $data');
                        }
                        */
                        userData = {};
                        vmUserData = Vue.observable({ userData: userData });
                    }
                    return vmUserData.userData;
                }
            }
            /*
            $validate: {
              value: function(value: any) {
                if (value === undefined) {
                  value = parent[propName];
                }
                const err = validate(obj, value);
                if (err) {
                  return (vm.error = getRuleMessage(schema, err, value, $schema));
                  //return (vm.error = err);
                } else {
                  return (vm.error = null);
                }
              }
            }
            */
        });
        /*
    
        //rozdzielone na każdy typ osobno
    
        obj.$validate = (value: any) => {
          if (value === undefined) {
            value = parent[propName];
          }
          const err = validate(obj, value);
          if (err) {
            return (vm.error = getRuleMessage(schema, err, value, $schema));
            //return (vm.error = err);
          } else {
            return (vm.error = null);
          }
        };
    
        */
        // reactivedata.data = {};
        /*
        obj.$set = (prop: string, value: any) => {
          vm.$set(vm.data, prop, value);
        };
        */
        var need$root = false;
        // if (schema.wrapped === undefined) {
        var wrapValidRule = function (field, func) {
            if (func === void 0) { func = null; }
            if (schema[field] !== undefined) {
                if (typeof schema[field] !== 'number') {
                    need$root = true;
                    var v_1 = schema[field];
                    delete $schema[field];
                    // if (self.isSimpleField(v)) {
                    if (false) {
                        // console.log(field + ' simplefield:', v);
                        Object.defineProperty($schema, field, {
                            enumerable: true,
                            get: function () {
                                return vm.$options.$ext.$model[v_1];
                            }
                        });
                    }
                    else {
                        console.log("create valid function", v_1, parent);
                        useComputedModel = true;
                        var ff_1 = schema.cache["schema_" + field];
                        if (ff_1 === undefined) {
                            ff_1 = JSchema_1.validCalcFunction(v_1);
                            // console.log('calc func', ff.toString());
                            schema.cache["schema_" + field] = ff_1;
                        }
                        computed["schema_" + field] = {
                            get: function () {
                                // console.log('calc 2', field);
                                return ff_1.apply(parent, calcargs);
                            }
                        };
                        if (func) {
                            func(ff_1.apply(parent, calcargs));
                            watch["schema_" + field] = func;
                        }
                        // delete $schema[field];
                        Object.defineProperty($schema, field, {
                            enumerable: true,
                            get: function () {
                                return vm["schema_" + field];
                            }
                        });
                    }
                }
                else {
                    // @ts-ignore
                    $schema[field] = schema[field];
                }
            }
            return false;
        };
        // let ruletime = (new Date()).getTime();
        if (!self.options.disableValidations) {
            wrapValidRule('maxLength');
            wrapValidRule('minLength');
            wrapValidRule('maxItems');
            wrapValidRule('minItems');
            wrapValidRule('minimum');
            wrapValidRule('maximum');
            wrapValidRule('exclusiveMaximum');
            wrapValidRule('exclusiveMinimum');
            // enum
            if (schema.enum !== undefined) {
                var v = schema.enum;
                if (Array.isArray(schema.enum)) {
                    $schema.enum = v;
                }
                else {
                    need$root = true;
                    var ff_2 = schema.cache["schema_enum"];
                    if (ff_2 === undefined) {
                        ff_2 = JSchema_1.validCalcFunction(v);
                        // ff = new Function(self.validCalcFunction(v));
                    }
                    computed.schema_required = {
                        get: function () {
                            return ff_2.apply(parent, calcargs);
                        }
                    };
                    Object.defineProperty($schema, 'enum', {
                        configurable: true,
                        enumerable: true,
                        get: function () {
                            return vm.schema_enum;
                        }
                    });
                }
            }
            if (schema.required && schema.type !== 'object' && typeof schema.required === 'string') {
                schema.fieldRequired = schema.required;
            }
            if (schema.fieldRequired !== undefined) {
                // need$root = true;
                var v_2 = schema.fieldRequired;
                if (typeof v_2 !== 'boolean') {
                    need$root = true;
                    // if (typeof v === 'string') {
                    // const ff = new Function(`with(this._data) {with(this._data.$model) {return (${v})};};`);
                    // delete schema.required;
                    // if (schema.fieldRequired !== undefined) {
                    //    delete schema.fieldRequired;
                    // }
                    // if (self.isSimpleField(v)) {
                    if (false) {
                        // if (false) {
                        console.log('required simplefield:', v_2);
                        Object.defineProperty($schema, 'fieldRequired', {
                            configurable: true,
                            enumerable: true,
                            get: function () {
                                return vm.$options.$ext.$model[v_2];
                            }
                        });
                    }
                    else {
                        // console.log('required field:', self.validCalcFunction(v));
                        useComputedModel = true;
                        var ff_3 = schema.cache["schema_required"];
                        if (ff_3 === undefined) {
                            ff_3 = JSchema_1.validCalcFunction(v_2);
                            // ff = new Function(self.validCalcFunction(v));
                        }
                        computed.schema_required = {
                            get: function () {
                                var res = ff_3.apply(parent, calcargs);
                                if (res === undefined) {
                                    return false;
                                }
                                return res;
                            }
                        };
                        Object.defineProperty($schema, 'fieldRequired', {
                            configurable: true,
                            enumerable: true,
                            get: function () {
                                return vm.schema_required;
                            }
                        });
                    }
                    // }
                }
                else {
                    $schema.fieldRequired = schema.fieldRequired;
                }
            }
        }
        /*
        obj.$validate = function(value: any) {
          if (value === undefined) {
            value = parent[propName];
          }
          const err = validate(obj, value);
          if (err) {
            return (vm.error = getRuleMessage(schema, err, value, $schema));
          } else {
            return (vm.error = null);
          }
        };
    */
        // console.log('rule time', propName, (new Date()).getTime() - ruletime);
        obj.$reset = function () {
            dirty = false;
            vm.error = null;
        };
        if (!computedOnly) {
            if (schema.type === 'object') {
                var schemaprops_1 = schema.properties;
                if (schemaprops_1) {
                    var mparent_1 = parent[propName];
                    if (mparent_1 === undefined) {
                        // console.log('recreate', propName);
                        var defvalue = JSchema_1.defaultValue(schema, true);
                        // console.log('recreate array',propName,defvalue);
                        // Vue.set(parent, propName, defvalue);
                        Vue.set(parent, propName, defvalue);
                        mparent_1 = parent[propName];
                    }
                    var required = schema.required || [];
                    var cacheProp_1 = {};
                    var _loop_1 = function (key) {
                        if (schemaprops_1.hasOwnProperty(key)) {
                            var element_1 = schemaprops_1[key];
                            if (element_1.fieldRequired === undefined) {
                                element_1.fieldRequired = required.indexOf(key) > -1;
                            }
                            // setTimeout(function() {
                            // self.wrapProperty(obj, mparent, key, element);
                            // let proptime = (new Date()).getTime();
                            if (this_1.options.wrapAll) {
                                var prop = (obj[key] = self.wrapProperty(obj, mparent_1, key, element_1));
                                if (dirty) {
                                    prop.$dirty = true;
                                }
                            }
                            else {
                                Object.defineProperty(obj, key, {
                                    enumerable: true,
                                    get: function () {
                                        var prop = cacheProp_1[key];
                                        if (prop === undefined) {
                                            prop = cacheProp_1[key] = self.wrapProperty(obj, mparent_1, key, element_1);
                                            if (dirty) {
                                                prop.$dirty = true;
                                            }
                                        }
                                        return prop;
                                    }
                                });
                                // console.log('prop time 1', key, (new Date()).getTime() - proptime);
                                // trzeba utworzyć tabele jeśli są undefined w modelu
                                if (element_1.type === 'array' || mparent_1[key] === undefined || anyCalc(element_1)) {
                                    // if (anyCalc(element)) {
                                    cacheProp_1[key] = self.wrapProperty(obj, mparent_1, key, element_1);
                                }
                            }
                            // console.log('prop time', key, (new Date()).getTime() - proptime);
                        }
                    };
                    var this_1 = this;
                    for (var key in schemaprops_1) {
                        _loop_1(key);
                    }
                    // Object.defineProperties(obj, {
                    //  $validateAll:
                    // });
                    /*
          
                    Object.defineProperties(obj, {
                      $validateAll: {
                        value: (result: any[]) => {
                          if (result === undefined) {
                            result = [];
                          }
          
                          for (const key in schemaprops) {
                            obj[key].$validateAll(result);
                          }
                          return result;
                        }
                      },
                      $validateSection: {
                        value: (section: string, result: any[]) => {
                          if (result === undefined) {
                            result = [];
                          }
          
                          for (const key in schemaprops) {
                            obj[key].$validateSection(section, result);
                          }
                          return result;
                        }
                      }
                    });
          
                    */
                    obj.$validateAll = function (result) {
                        if (result === undefined) {
                            result = [];
                        }
                        dirty = true;
                        for (var key in schemaprops_1) {
                            obj[key].$validateAll(result);
                        }
                        return result;
                    };
                    obj.$validateSection = function (section, result) {
                        if (result === undefined) {
                            result = [];
                        }
                        for (var key in schemaprops_1) {
                            obj[key].$validateSection(section, result);
                        }
                        return result;
                    };
                    obj.$validate = function (value) {
                        dirty = true;
                        if (obj.$isRoot) {
                            // self.startDirty = true;
                            self.options.startDirty = true;
                        }
                        return null;
                        if (value === undefined) {
                            value = mparent_1;
                        }
                    };
                    obj.$reset = function () {
                        for (var key in cacheProp_1) {
                            var prop = cacheProp_1[key];
                            if (prop !== undefined) {
                                prop.$reset();
                            }
                        }
                        dirty = false;
                        if (obj.$isRoot) {
                            self.options.startDirty = false;
                        }
                        vm.error = null;
                    };
                    obj.$setData = function (value, path2, fixArraySize) {
                        return JSchema_1.setData(schema, mparent_1, value, path2, 0, self.Vue, fixArraySize);
                    };
                    obj.$dirtyList = function (result) {
                        if (result === undefined) {
                            result = [];
                        }
                        dirty = true;
                        for (var key in schemaprops_1) {
                            var prop = cacheProp_1[key];
                            if (prop) {
                                prop.$dirtyList(result);
                            }
                        }
                        return result;
                    };
                }
            }
            else if (schema.type === 'array') {
                var schitems_1 = schema.items;
                if (schitems_1 !== undefined) {
                    if (self.arrayAsObject) {
                        reactivedata.items = {};
                    }
                    else {
                        // reactivedata.items = [];
                    }
                    // przeniesiono do get $items
                    if (true) {
                        /*
                        const deep = schitems.type !== 'object';
                        if (deep) {
                          console.log('$watch deep', propName);
                        }
                        */
                        useComputedModel = true;
                        watch.items = {
                            // deep,
                            handler: function (newValue) {
                                // console.log('watch $items ' + propName);
                                /*
                                if ($schema.fieldRequired) {
                                  if (newValue === null || newValue.length === 0) {
                                    this.error = getRuleMessage(schema, 'required', newValue, $schema);
                                    return;
                                  }
                                }
                                */
                                if (schema.debug) {
                                    debugger;
                                }
                                dirty = true;
                                // if (dirty) {
                                obj.$validate(parent[propName]);
                                // }
                                /*
                                const vvv = validate(obj, newValue);
                                if (vvv) {
                                  this.error = getRuleMessage(schema, vvv, newValue, $schema);
                                } else {
                                  this.error = null;
                                }
                                */
                                // console.log("validate array "+propName,vvv);
                            }
                        };
                    }
                    var usesubitem_1 = true;
                    var subitemcache_1 = [];
                    var mparent_2 = parent[propName];
                    if (mparent_2 === undefined) {
                        // Vue.set(parent, propName, []);
                        // mparent = parent[propName];
                        var defvalue = JSchema_1.defaultValue(schema, true);
                        // console.log('recreate array',propName,defvalue);
                        Vue.set(parent, propName, defvalue);
                        mparent_2 = parent[propName];
                    }
                    // initial validate
                    // obj.$validate(mparent);
                    // wypelnianie tabeli mozna opoznic
                    var mlength_1 = mparent_2.length;
                    if (mlength_1 && !self.options.disableCalculations && !self.options.wrapAll) {
                        var needCalc = anyCalc(schitems_1);
                        var props = schitems_1.properties;
                        if (needCalc && props) {
                            // są jakieś pola wymagające kalkulacji
                            // $root,$parent,$parent2,$parent3,$external,$methods,$obj
                            var paramdata = [root.$model, mparent_2, {}, {}, self.external, schemaMethods_1.default, , null];
                            if (dest) {
                                calcargs[2] = dest.$parent;
                                if (dest.$parent) {
                                    calcargs[3] = dest.$parent.$parent;
                                }
                            }
                            //  let props = schitems.properties;
                            for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
                                var schkey = _a[_i];
                                var schitem = props[schkey];
                                if (schitem.calc) {
                                    var stime = new Date().getTime();
                                    var calcFunc = JSchema_1.calcFunction(schitem, true);
                                    var $mparent = {
                                        $parent: obj,
                                        $key: 0
                                    };
                                    paramdata[6] = { $key: schkey, $parent: $mparent };
                                    try {
                                        // for (let i = 0; i < mlength; i++) {
                                        //  paramdata[6].$parent.$key = i;
                                        for (; $mparent.$key < mlength_1; $mparent.$key++) {
                                            var res = calcFunc.apply(mparent_2[$mparent.$key], paramdata);
                                            if (res !== undefined) {
                                                Vue.set(mparent_2[$mparent.$key], schkey, res);
                                            }
                                            // mparent[$mparent.$key][schkey] = calcFunc.apply(mparent[$mparent.$key], paramdata);
                                        }
                                    }
                                    catch (err) {
                                        if (process.env.NODE_ENV === 'development') {
                                            console.error('ERR calc:model result', err);
                                        }
                                        // moze się wywalić wiec spokojnie
                                        continue;
                                    }
                                    // console.log(`calc ${schkey} in ${propName}[${mlength}]`, new Date().getTime() - stime);
                                }
                                else if (schitem.aggregate) {
                                    if (process.env.NODE_ENV === 'development') {
                                        console.time('agg:model ' + path(this) + '[].' + schkey);
                                        // console.info('agg:model', new Date().getTime() - stime);
                                    }
                                    var stime = new Date().getTime();
                                    var aggFunc = JSchema_1.aggregateFunction(schitem, true);
                                    var $mparent = {
                                        $parent: obj,
                                        $key: 0
                                    };
                                    paramdata[6] = { $key: schkey, $parent: $mparent };
                                    try {
                                        // for (let i = 0; i < mlength; i++) {
                                        //  paramdata[6].$parent.$key = i;
                                        for (; $mparent.$key < mlength_1; $mparent.$key++) {
                                            var res = aggFunc.apply(mparent_2[$mparent.$key], paramdata);
                                            // mparent[$mparent.$key][schkey] = res;
                                            if (res !== undefined) {
                                                Vue.set(mparent_2[$mparent.$key], schkey, res);
                                            }
                                            // mparent[$mparent.$key][schkey] = calcFunc.apply(mparent[$mparent.$key], paramdata);
                                        }
                                        if (process.env.NODE_ENV === 'development') {
                                            console.timeEnd('agg:model ' + path(this) + '[].' + schkey);
                                            //  console.info('agg:model', new Date().getTime() - stime);
                                        }
                                    }
                                    catch (err) {
                                        if (process.env.NODE_ENV === 'development') {
                                            console.warn('agg:model rerror', err);
                                            console.timeEnd('agg:model ' + path(this) + '[].' + schkey);
                                        }
                                        // moze się wywalić wiec spokojnie
                                        continue;
                                    }
                                }
                                // if (schitems.calc) || (schitem.summary) || (schitem.agg)
                            }
                        }
                    }
                    var propcache_1 = {};
                    var ntable_1 = [];
                    var addRow_1 = function (rowIndex) {
                        var ssubitem = new Object();
                        // const ssubitem: any = { $key: rowIndex };
                        // let subitem: any;
                        Object.defineProperties(ssubitem, {
                            $key: {
                                writable: true,
                                /*
                                get() {
                                  return rowIndex;
                                },
                                set(newValue) {
                                  rowIndex = newValue;
                                  if (subitem) {
                                    subitem.$key = newValue;
                                  }
                                }
                                */
                                value: rowIndex
                            },
                            $item: {
                                // value: self.wrapProperty(obj, mparent, ff, schema.items as JSONSchema),
                                get: function () {
                                    var _this = this;
                                    var subitem = subitemcache_1[this.$key];
                                    if (subitem === undefined) {
                                        // let stime = (new Date()).getTime();
                                        // console.log('get $item');
                                        subitemcache_1[this.$key] = subitem = self.wrapProperty(obj, mparent_2, this.$key, schitems_1);
                                        // subitem = self.wrapProperty(obj, mparent, this.$key, schitems);
                                        Object.defineProperties(subitem, {
                                            $removeRow: {
                                                value: function () { return obj.$removeRow(_this.$key); }
                                            },
                                            $moveUp: {
                                                value: function () { return obj.$moveUp(_this.$key); }
                                            },
                                            $moveDown: {
                                                value: function () { return obj.$moveDown(_this.$key); }
                                            },
                                            $clear: {
                                                value: function () { return obj.$clearRow(_this.$key); }
                                            }
                                        });
                                        /*
                    
                                        subitem.$removeRow = function() {
                                          obj.$removeRow(this.$key);
                                        };
                                        subitem.$moveUp = function() {
                                          obj.$moveUp(this.$key);
                                        };
                                        subitem.$moveDown = function() {
                                          obj.$moveDown(this.$key);
                                        };
                                        subitem.$clear = function() {
                                          obj.$clearRow(this.$key);
                                        };
                                        */
                                        // console.log("wrap",propName,this.$key,((new Date()).getTime()-stime)+"ms")
                                        // console.log("newsubitem",i,subitem.$key);
                                    }
                                    else {
                                        // console.log("cachedsubitem",this.$key,subitem.$key);
                                    }
                                    return subitem;
                                }
                            }
                        });
                        /*
                        if (needCalc) {
                          subitemcache[ff] = self.wrapProperty(obj, mparent, ff, schitems);
                        }
                        */
                        ntable_1.push(ssubitem);
                        if (self.options.wrapAll) {
                            var a = ssubitem.$item;
                        }
                    };
                    var clearCached_1 = function () {
                        // destroy
                        for (var i = 0; i < subitemcache_1.length; i++) {
                            var item = subitemcache_1[i];
                            if (item !== undefined) {
                                item.$destroy();
                            }
                        }
                        subitemcache_1 = [];
                    };
                    // tworzenie tablicy
                    if (true) {
                        this.runAsync(function () {
                            var stime = new Date().getTime();
                            for (var i = 0; i < mlength_1; i++) {
                                /*
                
                                                if (self.arrayAsObject) {
                                                    Object.defineProperty(reactivedata.items, i, {
                                                        enumerable: true,
                                                        configurable: true,
                                                        get() {
                                                            let subitem = propcache[i];
                                                            if (subitem !== undefined) return subitem;
                                                            console.log("get array item", i);
                                                            if (i < mparent.length) {
                                                                subitem = self.wrapProperty(obj, mparent, i, schema.items);
                                                                subitem.$removeRow = function () {
                                                                    obj.$removeRow(this.$key);
                                                                }
                                                                return propcache[i] = subitem;
                                                            }
                                                        }
                                                    })
                
                
                                                } else {
                                                    */
                                if (usesubitem_1) {
                                    addRow_1(i);
                                }
                                else {
                                    var subitem = self.wrapProperty(obj, mparent_2, i, schitems_1);
                                    subitem.$removeRow = function () {
                                        obj.$removeRow(this.$key);
                                    };
                                    // reactivedata.items.push(subitem);
                                    ntable_1.push(subitem);
                                }
                            }
                            // reactivedata.items = ntable;
                            // console.log('reactivedata.items', ntable);
                            // console.log('wraptable', obj.$path, (new Date()).getTime() - stime, ntable.length);
                        });
                        computed.items = function () {
                            // tylko po to eby reagował na zmiany
                            var smodel = parent[propName];
                            // console.log('get computed ntable', ntable.length);
                            /*
                            console.log('watch $items');
                            if (schema.required) {
                              if (smodel === null || smodel.length === 0) {
                                vm.error = getRuleMessage(schema, 'required', smodel);
                                return;
                              }
                            }
                            const vvv = validate(obj, smodel);
                            if (vvv) {
                              vm.error = getRuleMessage(schema, vvv, smodel);
                            } else {
                              vm.error = null;
                            }
                            */
                            // automatyczne rozszerzanie
                            var l = smodel.length;
                            // console.log('mparent.length', mparent.length);
                            if (l > ntable_1.length) {
                                // console.log('autogrow', l, ntable.length);
                                while (ntable_1.length < l) {
                                    // console.log('auto add ntable', ntable.length);
                                    JSchema_1.fixData(schitems_1, smodel[ntable_1.length], self.Vue);
                                    addRow_1(ntable_1.length);
                                }
                            }
                            else if (l < ntable_1.length) {
                                // console.log('autoremove', l, ntable.length);
                                clearCached_1();
                                ntable_1.length = l;
                                // ntable = [];
                                // for (let i = 0; i < mlength; i++) {
                                //  addRow(i);
                                // }
                            }
                            return ntable_1;
                            // return [];
                        };
                    }
                    var cachedItems_1;
                    var cachedKey_1 = '';
                    /*
          
                    Object.defineProperties(obj, {
                      $validateAll: {
                        value: (result: any[]) => {
                          if (result === undefined) {
                            result = [];
                          }
                          if (obj.$validate(mparent) !== null) {
                            result.push(obj);
                          }
          
                          for (let i = 0; i < ntable.length; i++) {
                            let propRes = ntable[i].$item.$validateAll(result);
                          }
                          return result;
                        }
                      },
                      $validateSection: {
                        value: (section: string, result: any[]) => {
                          if (result === undefined) {
                            result = [];
                          }
          
                          if (section === formSection && obj.$validate(mparent) !== null) {
                            result.push(obj);
                          }
          
                          for (let i = 0; i < ntable.length; i++) {
                            let propRes = ntable[i].$item.$validateSection(section, result);
                          }
                          return result;
                        }
                      }
                    });
                    */
                    obj.$validateAll = function (result) {
                        if (result === undefined) {
                            result = [];
                        }
                        if (obj.$validate(mparent_2) !== null) {
                            result.push(obj);
                        }
                        for (var i = 0; i < ntable_1.length; i++) {
                            var propRes = ntable_1[i].$item.$validateAll(result);
                        }
                        return result;
                    };
                    obj.$validateSection = function (section, result) {
                        if (result === undefined) {
                            result = [];
                        }
                        if (section === formSection && obj.$validate(mparent_2) !== null) {
                            result.push(obj);
                        }
                        for (var i = 0; i < ntable_1.length; i++) {
                            var propRes = ntable_1[i].$item.$validateSection(section, result);
                        }
                        return result;
                    };
                    obj.$validate = function (value) {
                        if (value === undefined) {
                            value = mparent_2;
                        }
                        if (value === undefined || value === null) {
                            if ($schema.fieldRequired) {
                                return (vm.error = getRuleMessage(schema, 'required', value, $schema));
                            }
                            else {
                                return (vm.error = null);
                            }
                        }
                        var err = validate(obj, value);
                        if (err) {
                            return (vm.error = getRuleMessage(schema, err, value, $schema));
                            // return (vm.error = err);
                        }
                        else {
                            return (vm.error = null);
                        }
                    };
                    obj.$reset = function () {
                        for (var i = 0; i < mparent_2.length; i++) {
                            var subitem = subitemcache_1[i];
                            if (subitem !== undefined) {
                                subitem.$reset();
                            }
                        }
                        dirty = false;
                        vm.error = null;
                    };
                    obj.$dirtyList = function (result) {
                        if (result === undefined) {
                            result = [];
                        }
                        for (var i = 0; i < mparent_2.length; i++) {
                            var subitem = subitemcache_1[i];
                            if (subitem !== undefined) {
                                subitem.$dirtyList(result);
                            }
                        }
                        return result;
                    };
                    obj.$setData = function (value, path2, fixArraySize) {
                        return JSchema_1.setData(schema, mparent_2, value, path2, 0, self.Vue, fixArraySize);
                    };
                    obj.$addRow = function (nvalue, count) {
                        if (count === void 0) { count = 1; }
                        // let mparent2: any = parent[propName];
                        var mparent2 = mparent_2;
                        cachedKey_1 = '';
                        if (mparent2 === undefined) {
                            // Vue.set(parent, propName, []);
                            var defvalue = JSchema_1.defaultValue(schema, true);
                            // console.log('recreate array',propName,defvalue);
                            Vue.set(parent, propName, defvalue);
                            mparent2 = parent[propName];
                        }
                        if ($schema.length !== undefined && mparent2.length === $schema.length) {
                            return false;
                        }
                        var startindex = mparent2.length;
                        for (var i = 0; i < count; i++) {
                            // let nvalue2 = nvalue || {};
                            var nvalue2 = null;
                            if (schitems_1.type === 'object') {
                                nvalue2 = JSchema_1.defaultValue(schitems_1, true);
                                // console.log('addRow default', propName, nvalue2);
                                if (nvalue) {
                                    nvalue2 = Object.assign(nvalue2, nvalue);
                                }
                                mparent2.push(nvalue2);
                            }
                            else {
                                if (nvalue !== undefined) {
                                    nvalue2 = nvalue;
                                }
                                else {
                                    nvalue2 = JSchema_1.defaultValue(schitems_1, true);
                                }
                                Vue.set(mparent2, startindex, nvalue2);
                                if (process.env.NODE_ENV === 'development') {
                                    console.log('vue set array item', startindex, nvalue2, mparent2.length);
                                }
                                // mparent2.push(nvalue2);
                            }
                            // const nvalue2 = nvalue !== undefined ? JSON.parse(JSON.stringify(nvalue)) : {};
                            // let index = mparent.length - 1;
                            // opóźnij
                        }
                        self.runAsync(function () {
                            // let stime=(new Date()).getTime();
                            var temparr = [];
                            var _loop_2 = function (i) {
                                if (self.arrayAsObject) {
                                    Object.defineProperty(reactivedata.items, startindex + i, {
                                        enumerable: true,
                                        configurable: true,
                                        get: function () {
                                            var subitem = propcache_1[i];
                                            if (subitem !== undefined) {
                                                return subitem;
                                            }
                                            if (process.env.NODE_ENV === 'development') {
                                                console.log('get array items', i);
                                            }
                                            if (startindex + i < mparent_2.length) {
                                                subitem = self.wrapProperty(obj, mparent2, startindex + i, schitems_1);
                                                subitem.$removeRow = function () {
                                                    obj.$removeRow(this.$key);
                                                };
                                                subitem.$moveUp = function () {
                                                    obj.$moveUp(this.$key);
                                                };
                                                subitem.$moveDown = function () {
                                                    obj.$moveDown(this.$key);
                                                };
                                                subitem.$clear = function () {
                                                    obj.$clearRow(this.$key);
                                                };
                                                return (propcache_1[i] = subitem);
                                            }
                                        }
                                    });
                                }
                                else {
                                    if (usesubitem_1) {
                                        addRow_1(startindex + i);
                                    }
                                    else {
                                        var subitem = self.wrapProperty(obj, mparent2, startindex + i, schitems_1);
                                        subitem.$removeRow = function () {
                                            obj.$removeRow(this.$key);
                                        };
                                        // reactivedata.items.push(subitem);
                                        temparr.push(subitem);
                                    }
                                }
                            };
                            for (var i = 0; i < count; i++) {
                                _loop_2(i);
                            }
                        });
                        return true;
                    };
                    obj.$removeRow = function (index) {
                        // usuwanie i reindex
                        // let index = obj.$key;
                        // const stime = new Date().getTime();
                        if (process.env.NODE_ENV === 'development') {
                            console.time('$removeRow');
                        }
                        var modeltable = mparent_2;
                        var schematable = vm.items;
                        cachedKey_1 = '';
                        if (self.arrayAsObject) {
                            modeltable.splice(index, 1);
                            for (var i = index; i < modeltable.length; i++) {
                                if (propcache_1[i] !== undefined) {
                                    var nvalue = propcache_1[i + 1];
                                    if (nvalue !== undefined) {
                                        if (process.env.NODE_ENV === 'development') {
                                            console.log('propcache', i, nvalue);
                                        }
                                        nvalue.$key = i;
                                    }
                                    propcache_1[i] = nvalue;
                                }
                            }
                            delete propcache_1[modeltable.length];
                            // Vue.delete(reactivedata.items,modeltable.length);
                            delete reactivedata.items[modeltable.length];
                        }
                        else {
                            // console.log(modeltable.length,schematable.length,subitemcache.length);
                            // console.log(JSON.stringify(subitemcache.map(x=>x.$key)));
                            if (usesubitem_1) {
                                // schematable.splice(index, 1);
                                if ($schema.length !== undefined && ntable_1.length === $schema.length) {
                                    return false;
                                }
                                ntable_1.splice(index, 1);
                                // onsole.log(modeltable.length,schematable.length,subitemcache.length);
                                // console.log(JSON.stringify(subitemcache.map(x=>x.$key)));
                                subitemcache_1.splice(index, 1);
                                // console.log(modeltable.length,schematable.length,subitemcache.length);
                                // console.log(JSON.stringify(subitemcache.map(x=>x.$key)));
                                var l = schematable.length;
                                for (var i = index; i < l; i++) {
                                    ntable_1[i].$key = i;
                                    if (subitemcache_1[i] !== undefined) {
                                        subitemcache_1[i].$key = i;
                                    }
                                    // console.log(`schematable[${i}].$item`, ntable[i].$item);
                                }
                                // console.timeEnd('$removeRow');
                                modeltable.splice(index, 1); // bo na tym jest event ?
                                // console.log(JSON.stringify(subitemcache.map(x=>x.$key)));
                                if (false) {
                                    if (modeltable.length === 0 && $schema.minItems !== undefined && $schema.minItems > 0) {
                                        obj.$addRow(undefined, 1 /* $schema.minLength - modeltable.length */);
                                    }
                                }
                            }
                            else {
                                modeltable.splice(index, 1);
                                schematable.splice(index, 1);
                                for (var i = index; i < schematable.length; i++) {
                                    schematable[i].$key = i;
                                }
                            }
                        }
                        if (process.env.NODE_ENV === 'development') {
                            console.timeEnd('$removeRow');
                        }
                    };
                    obj.$clearRow = function (index) {
                        var nitem = JSchema_1.defaultValue(schema);
                        if (subitemcache_1[index] !== undefined) {
                            subitemcache_1[index].$destroy();
                            subitemcache_1[index] = undefined;
                        }
                        Vue.set(mparent_2, index, nitem);
                    };
                    obj.$exchangeRow = function (index1, index2) {
                        cachedKey_1 = '';
                        if (process.env.NODE_ENV === 'development') {
                            console.time("$exchangeRow(" + index1 + "," + index2 + ")");
                        }
                        var item1 = mparent_2[index1];
                        var item2 = mparent_2[index2];
                        if (subitemcache_1[index1] !== undefined) {
                            subitemcache_1[index1].$destroy();
                            subitemcache_1[index1] = undefined;
                        }
                        if (subitemcache_1[index2] !== undefined) {
                            subitemcache_1[index2].$destroy();
                            subitemcache_1[index2] = undefined;
                        }
                        Vue.set(mparent_2, index1, item2);
                        Vue.set(mparent_2, index2, item1);
                        // mparent[index1] = item2;
                        // mparent[index2] = item1;
                        if (process.env.NODE_ENV === 'development') {
                            console.timeEnd("$exchangeRow(" + index1 + "," + index2 + ")");
                        }
                        // console.log('exchanged', index1, index2);
                    };
                    obj.$moveUp = function (index) {
                        if (index > 0) {
                            obj.$exchangeRow(index, index - 1);
                        }
                    };
                    obj.$moveDown = function (index) {
                        if (index < mparent_2.length - 1) {
                            obj.$exchangeRow(index, index + 1);
                        }
                    };
                    obj.$sort = function (field) {
                        // let stime = new Date().getTime();
                        if (process.env.NODE_ENV === 'development') {
                            console.time("$sort(" + propName + "," + field + ")");
                        }
                        cachedKey_1 = '';
                        mparent_2 = parent[propName].sort(function (a, b) { return (b[field] === a[field] ? 0 : b[field] > a[field] ? -1 : 1); });
                        // mparent = parent[propName] = narray;
                        // destroy
                        clearCached_1();
                        if (process.env.NODE_ENV === 'development') {
                            console.timeEnd("$sort(" + propName + "," + field + ")");
                            console.log("   [0]." + field + "=" + mparent_2[0][field] + (", [" + (mparent_2.length - 1) + "]." + field) + ("=" + mparent_2[mparent_2.length - 1][field]));
                        }
                        // tslint:disable-next-line: max-line-length
                        // console.log('sorting', propName, field, new Date().getTime() - stime, mparent[0][field], mparent[mparent.length - 1][field]);
                    };
                    // vm.data.order = '';
                    // reactivedata.data.order = '';
                    Vue.set(obj.$data, 'order', '');
                    // obj.$data.order = '';
                    Object.defineProperties(obj, {
                        pageNumber: {
                            get: function () {
                                // @ts-ignore
                                // return vm.data['pageNumber'] || 0;
                                // return vm.data.pageNumber || 0;
                                return obj.$data.pageNumber || 0;
                            },
                            set: function (newValue) {
                                if (newValue < 0) {
                                    Vue.set(obj.$data, 'pageNumber', 0);
                                }
                                else if (newValue >= this.pageCount) {
                                    if (process.env.NODE_ENV === 'development') {
                                        console.log('overflow pagenumber', newValue, this.pageCount - 1);
                                    }
                                    Vue.set(obj.$data, 'pageNumber', this.pageCount - 1);
                                }
                                else {
                                    Vue.set(obj.$data, 'pageNumber', newValue);
                                }
                            }
                        },
                        pageSize: {
                            get: function () {
                                return obj.$data.pageSize;
                                // return vm.data['pageSize'] || 0;
                            },
                            set: function (newValue) {
                                Vue.set(obj.$data, 'pageSize', newValue);
                                if (this.pageNumber >= this.pageCount) {
                                    this.pageNumber = this.pageCount - 1;
                                }
                            }
                        },
                        pageCount: {
                            get: function () {
                                var smodel = parent[propName];
                                return Math.ceil(smodel.length / this.pageSize);
                            }
                        },
                        order: {
                            get: function () {
                                return obj.$data.order;
                            },
                            set: function (newValue) {
                                Vue.set(obj.$data, 'order', newValue);
                            }
                        }
                    });
                    obj.$filter = function (func) {
                        if (func) {
                            return ntable_1.filter(func);
                        }
                        return ntable_1;
                    };
                    obj.$getItems = function (start, count) {
                        // console.log('dssdfsdfs');
                        var mparent2 = parent[propName];
                        start = start || 0;
                        if (count && obj.pageSize !== count) {
                            // console.log('set pageSize', count);
                            obj.pageSize = count;
                        }
                        var end = count;
                        if (end === undefined) {
                            end = mparent2.length;
                        }
                        else {
                            end += start;
                            if (end >= mparent2.length) {
                                end = mparent2.length;
                            }
                        }
                        var stime = new Date().getTime();
                        var res = [];
                        if (usesubitem_1) {
                            var order_1 = obj.order;
                            var nkey = start + "|" + end + "|" + order_1;
                            if (nkey === cachedKey_1) {
                                // console.log('return cached data', new Date().getTime() - stime);
                                return cachedItems_1;
                            }
                            if (order_1) {
                                if (process.env.NODE_ENV === 'development') {
                                    console.time("$getItems.order('" + order_1 + "'," + start + "," + end + ")");
                                }
                                // let stime = new Date().getTime();
                                var otable = Array.from(ntable_1);
                                otable.sort(function (a, b) { return (mparent2[b.$key][order_1] === mparent2[a.$key][order_1] ? 0 : mparent2[b.$key][order_1] > mparent2[a.$key][order_1] ? -1 : 1); });
                                // console.log('order by', (new Date()).getTime() - stime, order, otable[0].$item, ntable[0].$item);
                                // tslint:disable-next-line: max-line-length
                                // let narray = parent[propName].sort((a: any, b: any) => (b[field] === a[field]) ? 0 : (b[field] > a[field]) ? -1 : 1);
                                for (var i = start; i < end; i++) {
                                    res.push(otable[i].$item);
                                }
                                if (process.env.NODE_ENV === 'development') {
                                    console.time("$getItems.order('" + order_1 + "'," + start + "," + end + ")");
                                }
                                // console.log('return ordered data', new Date().getTime() - stime);
                            }
                            else {
                                if (process.env.NODE_ENV === 'development') {
                                    console.time("$getItems(" + start + "," + end + ")");
                                }
                                // console.log('not ordered', ntable[0].$item);
                                for (var i = start; i < end; i++) {
                                    res.push(ntable_1[i].$item);
                                }
                                if (process.env.NODE_ENV === 'development') {
                                    console.timeEnd("$getItems(" + start + "," + end + ")");
                                }
                            }
                            cachedItems_1 = res;
                            cachedKey_1 = nkey;
                            // const aa: any[] = this.$items as WrappedProperty[];
                            // console.log("$getItems",start,end,res.length,aa.length);
                            // console.log("$getItems", propName, start, end, res.length, (new Date()).getTime() - stime);
                            // return res;
                            // res = reactivedata.items.slice(start, end).map((x: any) => x.$item);
                        }
                        else {
                            res = reactivedata.items.slice(start, end);
                        }
                        // console.log('$getItems.slide', (new Date()).getTime() - stime, res);
                        return res;
                        // return
                    };
                    obj.$getPage = function (page, pageSize) {
                        if (pageSize === void 0) { pageSize = 25; }
                        // console.log('get page');
                        return this.$getItems(page * pageSize, pageSize);
                    };
                    // length
                    wrapValidRule('length', function (newValue) {
                        console.log('length newValue', newValue);
                        schema.length = newValue;
                        var stable = parent[propName];
                        if (stable.length !== newValue) {
                            while (stable.length > newValue) {
                                obj.$removeRow(stable.length - 1);
                            }
                            while (stable.length < newValue) {
                                // obj.$addRow(undefined, 1);
                                obj.$addRow(undefined, newValue - stable.length);
                            }
                        }
                        return newValue;
                    });
                }
            }
            else {
                var mvalue = parent[propName];
                // console.log('current value', propName, JSON.stringify(mvalue));
                if (mvalue === undefined) {
                    Vue.set(parent, propName, JSchema_1.defaultValue(schema, true));
                    // parent[propName] = defaultValue(schema, true);
                    // console.log('current value fixed', propName, parent);
                }
                obj.$setData = function (value) {
                    Vue.set(parent, propName, value);
                    return true;
                    // return setData(schema, mparent, value, path, 0, self.Vue);
                };
                obj.$dirtyList = function (result) {
                    if (result === undefined) {
                        result = [];
                    }
                    if (dirty) {
                        result.push(obj);
                    }
                    return result;
                };
            }
        }
        // tworzenie funkcji walidującej
        if (!self.options.disableValidations && schema.validFunc) {
            need$root = true;
            var ff_4 = schema.validFuncCompiled;
            if (ff_4 === undefined) {
                var stext = schema.validFunc;
                if (stext.indexOf('$root') > -1) {
                    need$root = true;
                }
                if (stext.indexOf('$parent') > -1) {
                    need$root = true;
                    stext = stext.replace(/\$parent\.\$parent\.\$parent\./g, '$parent3.');
                    stext = stext.replace(/\$parent\.\$parent\./g, '$parent2.');
                    stext = stext.replace(/\$parent\./g, '$parent.');
                }
                if (stext.indexOf('{') === -1) {
                    stext = "{$result=(" + stext + ")}";
                }
                var ffunc = "var $value=this." + propName + ";var $result=null;" + stext + ";";
                // ffunc+=`${}`;
                // ffunc += 'with($data) {';
                // ffunc += `with(parent) ${stext};`;
                // ffunc += '};';
                // ffunc += `console.log('validFuncResult','${propName}',$result);`;
                ffunc += 'return $result;';
                if ((process.env.NODE_ENV === 'development') && schema.debug) {
                    ffunc = 'debugger;\r\n' + ffunc;
                }
                // schema.validFuncCompiled = ff = new Function('$data', 'parent', 'propName', ffunc);
                schema.validFuncCompiled = ff_4 = new Function(JSchema_1.funcParams, ffunc);
            }
            computed.validFunc = {
                get: function () {
                    // var $value=parent[propName];
                    // const funcvalue = ff(this._data, parent, propName);
                    var funcvalue = ff_4.apply(parent, calcargs);
                    if (funcvalue === true || funcvalue === undefined) {
                        return null;
                    }
                    if (funcvalue === false) {
                        return 'validFunc';
                    }
                    return funcvalue;
                }
            };
            /*
                  watch.validFunc = function (newValue) {
                      console.log('validFuncResult', newValue);
                  };
                  */
        }
        if (!self.options.disableCalculations) {
            // tworzenie funkcji wyliczjącej wartośc na podstawie innych pól
            if (schema.calc) {
                dirty = true;
                need$root = true;
                var calcFunc_1 = JSchema_1.calcFunction(schema, true, (process.env.NODE_ENV === 'development') && schema.debug);
                computed.calc = {
                    get: function () {
                        // if (schema.calc ==='this.Dotacja + this.SrodkiWlasne + this.WkladOsobowy + this.WkladRzeczowy + 5')
                        if (process.env.NODE_ENV === 'development') {
                            var res = calcFunc_1.apply(parent, calcargs);
                            // tslint:disable-next-line: max-line-length
                            // if (res === undefined || (isNaN(res) && (schema.type == 'number' || schema.type === 'integer' || schema.type === 'money'))) {
                            if ((res === undefined && schema.calc.when === undefined && schema.calc.indexOf('undefined') === -1) || res === NaN) {
                                console.error('ERR calc result=', res, propName, schema.calc);
                            }
                            return res;
                        }
                        else {
                            return calcFunc_1.apply(parent, calcargs);
                        }
                    }
                };
                // computed.calc = calcFunc;
            }
            // tworzenie funkcji sumującej wartość z tablicy
            if (schema.summary) {
                schema.aggregate = {
                    func: 'sum',
                    array: schema.summary.array,
                    property: schema.summary.property,
                    when: schema.summary.when,
                    if: schema.summary.if,
                    delay: schema.summary.delay
                };
                delete schema.summary;
            }
            // tworzenie funkcji sumującej wartość z tablicy
            if (schema.aggregate) {
                need$root = true;
                dirty = true;
                var aggregateFunc_1 = JSchema_1.aggregateFunction(schema, true, (process.env.NODE_ENV === 'development') && schema.debug);
                // if (schema.aggregate.async) {
                if (schema.aggregate.delay) {
                    // if (false) {
                    setTimeout(function () {
                        // console.log('delayed create aggregate',obj.$path);
                        var asyncVm = new Vue({
                            computed: {
                                aggregate: {
                                    get: function () {
                                        // console.log('delayed run aggregate', obj.$path);
                                        if (process.env.NODE_ENV === 'development') {
                                            var res = aggregateFunc_1.apply(parent, calcargs);
                                            if (res === undefined || res === NaN) {
                                                console.error('ERR aggregate:delay result=', res, propName, schema.calc);
                                            }
                                            return res;
                                        }
                                        else {
                                            return aggregateFunc_1.apply(parent, calcargs);
                                        }
                                    }
                                }
                            },
                            watch: {
                                aggregate: function (newValue) {
                                    Vue.set(parent, propName, newValue);
                                }
                            }
                        });
                        _this.vueInstances.push(asyncVm);
                    }, schema.aggregate.delay);
                }
                else {
                    computed.aggregate = {
                        get: function () {
                            if (process.env.NODE_ENV === 'development') {
                                if (schema.debug) {
                                    debugger;
                                }
                                var res = aggregateFunc_1.apply(parent, calcargs);
                                if (res === undefined || res === NaN) {
                                    console.error('ERR aggregate result', res, propName, schema.calc);
                                }
                                return res;
                            }
                            else {
                                return aggregateFunc_1.apply(parent, calcargs);
                            }
                            // return aggregateFunc()
                        }
                    };
                }
            }
        }
        if (need$root) {
            if (self.external) {
                // extraData = Object.assign({}, this.external);
                // extraData.$external = self.external;
                calcargs[4] = self.external;
                // console.log('set external', self.external);
            }
            calcargs[5] = schemaMethods_1.default;
            calcargs[6] = obj;
            calcargs[0] = root.$model;
            /*
            Object.defineProperty(calcargs, 0, {
              get() {
                return root.$model;
              }
            });
            */
            /*
            Object.defineProperty(extraData, '$root', {
              get() {
                return root.$model;
              }
            });
            */
            if (dest && dest.$parent !== undefined) {
                /*
                Object.defineProperty(extraData, '$parent', {
                  get() {
                    return (dest.$parent as WrappedProperty).$model;
                  }
                });
                */
                calcargs[1] = dest.$parent.$model;
                if (dest.$parent.$parent) {
                    /*
                    Object.defineProperty(extraData, '$parent2', {
                      get() {
                        return ((dest.$parent as WrappedProperty).$parent as WrappedProperty).$model;
                      }
                    });
                    */
                    calcargs[2] = dest.$parent.$parent.$model;
                    if (dest.$parent.$parent.$parent) {
                        calcargs[3] = dest.$parent.$parent.$parent.$model;
                    }
                    else {
                        // extraData.$parent3 = {};
                        calcargs[3] = {};
                    }
                }
                else {
                    // extraData.$parent2 = extraData.$parent3 = {};
                    calcargs[2] = calcargs[3] = {};
                }
            }
            else {
                // extraData.$parent = extraData.$parent2 = extraData.$parent3 = {};
                calcargs[1] = calcargs[2] = calcargs[3] = {};
            }
        }
        var svalueGetFunc = null;
        var svalueSetFunc = null;
        switch (schema.type) {
            case 'number':
            case 'integer':
            case 'money':
                obj.$validateAll = function (result) {
                    if (obj.$validate() !== null) {
                        result.push(obj);
                    }
                    return result;
                };
                obj.$validateSection = function (section, result) {
                    if (section === formSection && obj.$validate() !== null) {
                        result.push(obj);
                    }
                    return result;
                };
                obj.$validate = function (value) {
                    if (value === undefined) {
                        value = parent[propName];
                    }
                    dirty = true;
                    if (value === null) {
                        if (!typeok) {
                            return (vm.error = getRuleMessage(schema, 'type', value, $schema));
                        }
                        if ($schema.fieldRequired) {
                            return (vm.error = getRuleMessage(schema, 'required', value, $schema));
                        }
                        else {
                            return (vm.error = null);
                        }
                    }
                    var ivalue = +value;
                    var err = validate(obj, ivalue);
                    if (err) {
                        return (vm.error = getRuleMessage(schema, err, ivalue, $schema));
                        // return (vm.error = err);
                    }
                    else {
                        return (vm.error = null);
                    }
                };
                reactivedata.stringValue = null;
                svalueGetFunc = function () {
                    // if (propName =='cena') {
                    //    console.log('computed.model cena',parent);
                    // }
                    var ivalue = parent[propName];
                    // let ivalue = obj.$model;
                    if (dirty) {
                        obj.$validate(ivalue);
                    }
                    if (ivalue === null) {
                        if (vm.stringValue !== undefined && vm.stringValue !== null) {
                            return vm.stringValue;
                        }
                        else {
                            return '';
                        }
                    }
                    if (isNaN(+ivalue)) {
                        ivalue = 0;
                    }
                    // const err = validate(obj, ivalue);
                    // if (obj.$path === 'LiczbaOdbiorcowZadania') {
                    //  console.log('validate ', JSON.stringify(ivalue), JSON.stringify(err));
                    // }
                    // vm.error = err ? getRuleMessage(schema, err, ivalue, $schema) : null;
                    // let svalue = (""+self.mround(ivalue)).replace(".",",");
                    var svalue = '';
                    switch ($schema.type) {
                        case 'number':
                            svalue = fnumber_1.default(ivalue, schema.precision || 8);
                            break;
                        case 'money':
                            svalue = fmoney_1.default(ivalue, false, schema.precision || 2);
                            break;
                        case 'integer':
                            svalue = fnumber_1.default(ivalue, 0);
                            break;
                    }
                    // console.log($schema.type + 'Computed(get)', propName, JSON.stringify(svalue), err);
                    return svalue;
                };
                svalueSetFunc = function (newValue) {
                    typeok = true;
                    var ivalue = null;
                    if (self.options.dirtyOnInput) {
                        dirty = true;
                    }
                    // console.log('set model', JSON.stringify(newValue));
                    if (newValue === '' || newValue == null) {
                        if (dirty && $schema.fieldRequired) {
                            vm.error = getRuleMessage(schema, 'required', newValue, $schema);
                            // ok = false;
                            // typeok = false;
                        }
                        /*
                                      if (schema.default !== undefined) {
                                          ivalue = schema.default;
                                          //if (ivalue===0) {
                                          //    typeok=true;
                                          //}
                                      }
                                      */
                        ivalue = null;
                    }
                    else {
                        ivalue = +newValue.replace(',', '.');
                        if (isNaN(ivalue)) {
                            if (dirty) {
                                vm.error = getRuleMessage(schema, 'type', newValue, $schema);
                            }
                            typeok = false;
                            // this.stringValue = newValue;
                            // ivalue = schema.default || null;
                            ivalue = null;
                        }
                    }
                    savedValue = ivalue;
                    // if (this.focused) {
                    if (!typeok) {
                        // tslint:disable-next-line: no-console
                        // console.log('set $stringValue', newValue);
                        vm.stringValue = newValue;
                    }
                    else {
                        vm.stringValue = null;
                    }
                    var dvalue = 0;
                    if (ivalue === null) {
                        obj.$model = null;
                    }
                    else {
                        switch (schema.type) {
                            case 'integer':
                                // console.log('set model', obj.$path, JSON.stringify(ivalue), JSON.stringify(mround(ivalue, 0)));
                                dvalue = mround_1.default(ivalue, 0);
                                break;
                            case 'money':
                                dvalue = mround_1.default(ivalue, schema.precision || 2);
                                break;
                            case 'number':
                                dvalue = mround_1.default(ivalue, schema.precision || 8);
                                break;
                        }
                        // console.log(schema.type + 'Computed(set)', propName, JSON.stringify(dvalue), JSON.stringify(typeok));
                        // parent[propName] = dvalue;
                        obj.$model = dvalue;
                    }
                };
                break;
            case 'string':
            case 'text':
                obj.$validate = function (svalue) {
                    if (svalue === undefined) {
                        svalue = parent[propName];
                    }
                    dirty = true;
                    var req = $schema.fieldRequired;
                    // console.log('propName.get()', req, svalue);
                    if (svalue === '' || svalue === null) {
                        if (req) {
                            return (vm.error = getRuleMessage(schema, 'required', svalue, $schema));
                        }
                        else {
                            // pustego nie walidujemy
                            return (vm.error = null);
                        }
                    }
                    var err = validate(obj, svalue);
                    if (err) {
                        return (vm.error = getRuleMessage(schema, err, svalue, $schema));
                        // return (vm.error = err);
                    }
                    else {
                        return (vm.error = null);
                    }
                };
                obj.$validateAll = function (result) {
                    if (obj.$validate() !== null) {
                        result.push(obj);
                    }
                    return result;
                };
                obj.$validateSection = function (section, result) {
                    if (section === formSection && obj.$validate() !== null) {
                        result.push(obj);
                    }
                    return result;
                };
                svalueGetFunc = function () {
                    var svalue = parent[propName];
                    // if ($schema.format === 'date-time' && typeof propName === 'number') {
                    //  console.log('gettinf date-time', svalue, parent, JSON.stringify(propName));
                    // }
                    // let svalue = obj.$model;
                    if (dirty) {
                        obj.$validate(svalue);
                    }
                    switch ($schema.format) {
                        case 'date':
                            if (svalue && svalue.length >= 10) {
                                var nsvalue = svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                                svalue = nsvalue;
                            }
                            break;
                        case 'date-time':
                            if (svalue && svalue.length >= 10) {
                                var nsvalue = svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                                var ntvalue = svalue.substr(11, 8);
                                if (ntvalue !== '00:00:00') {
                                    nsvalue += ' ' + ntvalue;
                                }
                                // console.log('get date-time', svalue, nsvalue, ntvalue);
                                svalue = nsvalue;
                            }
                            break;
                    }
                    return svalue || '';
                };
                svalueSetFunc = function (newValue) {
                    typeok = true;
                    if (!dirty && self.options.dirtyOnInput) {
                        dirty = true;
                    }
                    /*
                    if (newValue === '' || newValue === null) {
                      if ($schema.fieldRequired) {
                        vm.error = getRuleMessage(schema, 'required', newValue, $schema);
                        // console.log('empty required ' + propName, vm.error);
                        // ok = false;
                        typeok = false;
                      }
                      // newValue = '';
                    }
                    */
                    // check save type
                    if ($schema.format) {
                        switch ($schema.format) {
                            case 'date':
                                if (newValue && newValue.length >= 10) {
                                    newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2);
                                    // console.log('set date-time', newValue);
                                }
                                break;
                            case 'date-time':
                                if (newValue && newValue.length >= 10) {
                                    newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2);
                                    // console.log('set date-time', newValue);
                                }
                                break;
                        }
                    }
                    /*
                    if (!typeok) {
                      this.stringValue = newValue;
                    } else {
                      this.stringValue = null;
                    }
                    */
                    // parent[propName] = newValue;
                    obj.$model = newValue;
                    if ($schema.format === 'date-time') {
                        // console.log('date parent', parent);
                    }
                };
                break;
            case 'boolean':
                obj.$validateAll = function (result) {
                    if (obj.$validate() !== null) {
                        result.push(obj);
                    }
                    return result;
                };
                obj.$validateSection = function (section, result) {
                    if (section === formSection && obj.$validate() !== null) {
                        result.push(obj);
                    }
                    return result;
                };
                obj.$validate = function (value) {
                    if (value === undefined) {
                        value = parent[propName];
                    }
                    dirty = true;
                    if (value === null) {
                        if ($schema.fieldRequired) {
                            return (vm.error = getRuleMessage(schema, 'required', value, $schema));
                        }
                        else {
                            return (vm.error = null);
                        }
                    }
                    var ivalue = !!value;
                    if ($schema.fieldRequired && !ivalue) {
                        return (vm.error = getRuleMessage(schema, 'required', value, $schema));
                    }
                    var err = validate(obj, ivalue);
                    if (err) {
                        return (vm.error = getRuleMessage(schema, err, ivalue, $schema));
                        // return (vm.error = err);
                    }
                    else {
                        return (vm.error = null);
                    }
                };
                svalueGetFunc = function () {
                    var svalue = parent[propName];
                    if (dirty) {
                        var err = validate(obj, svalue);
                        vm.error = err ? getRuleMessage(schema, err, svalue, $schema) : null;
                    }
                    return svalue ? 'true' : 'false';
                };
                svalueSetFunc = function (newValue) {
                    if (!dirty && self.options.dirtyOnInput) {
                        dirty = true;
                    }
                    parent[propName] = newValue !== null && newValue !== 'null' && newValue !== 'false' && newValue !== 'off' && newValue !== '';
                };
                break;
            case 'array': {
                svalueGetFunc = function () { return obj.$model; };
                svalueSetFunc = function (newValue) {
                    if (!dirty && self.options.dirtyOnInput) {
                        dirty = true;
                    }
                    return (obj.$model = newValue);
                };
                break;
            }
            default:
                svalueGetFunc = function () { return obj.$model; };
                svalueSetFunc = function (newValue) {
                    // parent[propName] = newValue;
                    if (!dirty && self.options.dirtyOnInput) {
                        dirty = true;
                    }
                    return (obj.$model = newValue);
                };
                break;
        }
        reactivedata.error = null;
        // extraData.$key = propName;
        // extraData.$model = parent;
        // extraData.$schema = $schema;
        // extraData.$obj = obj;
        // extraData.mround = mround;
        if (computedOnly) {
            reactivedata.value = JSchema_1.defaultValue(schema, true);
            if (true) {
                /*
                        let propinfo = Object.getOwnPropertyDescriptor(parent, propName);
                        if (propinfo === undefined) {
                            Vue.set(parent, propName,)
        
                        }
                        */
                if (parent[propName] === undefined) {
                    Object.defineProperty(parent, propName, {
                        enumerable: false,
                        configurable: false,
                        get: function () {
                            return reactivedata.value;
                        }
                    });
                }
            }
        }
        var mixins = [];
        if (asyncComputed !== null) {
            // mixins.push()
        }
        // console.log('before create vm ' + propName, extraData);
        var vvtime = new Date().getTime();
        // debugger;
        if (useComputedModel || need$root) {
            computed.model = {
                get: svalueGetFunc,
                set: svalueSetFunc
            };
            vm = new Vue({
                data: function () {
                    return reactivedata;
                },
                computed: computed,
                watch: watch
                // methods: {
                //     mround,
                // },
                // $ext: extraData
            });
            self.vueInstances.push(vm);
            obj.$destroy = function () {
                vm.$destroy();
            };
        }
        else {
            vm = Vue.observable(reactivedata);
            obj.$destroy = function () {
                return;
            };
        }
        /*
    
        obj.$validate = function(value: any) {
          if (value === undefined) {
            value = parent[propName];
          }
          const err = validate(obj, value);
          if (err) {
            return (vm.error = getRuleMessage(schema, err, value, $schema));
          } else {
            return (vm.error = null);
          }
        };
        */
        if (schema.type === 'array') {
            // console.log('after create vm ' + propName, (new Date().getTime()) - vvtime, vm.items);
        }
        // console.log('after create vm ' + propName, (new Date().getTime()) - vvtime, extraData);
        if (typeof propName === 'number') {
            var prevModelValue_1;
            var prevSValue_1;
            Object.defineProperty(obj, '$value', {
                enumerable: true,
                get: function () {
                    var nvalue = obj.$model;
                    if (prevModelValue_1 === nvalue) {
                        // console.log('return cached:', prevSValue);
                        return prevSValue_1;
                    }
                    else {
                        prevModelValue_1 = nvalue;
                        return (prevSValue_1 = svalueGetFunc());
                    }
                },
                set: function (newValue) {
                    // vm.model = newValue;
                    svalueSetFunc(newValue);
                }
            });
        }
        else {
            if (useComputedModel) {
                Object.defineProperty(obj, '$value', {
                    enumerable: true,
                    get: function () {
                        return vm.model;
                    },
                    set: function (newValue) {
                        vm.model = newValue;
                    }
                });
            }
            else {
                Object.defineProperty(obj, '$value', {
                    enumerable: true,
                    get: function () {
                        /*
                      if (typeof propName === 'number') {
                        console.log('get $value', propName, vm, vm.model, obj.$model);
                        return obj.$model;
                        // console.log('get $value', propName, vm, vm.model);
                      } else {
                        return vm.model;
                      }
                      */
                        return svalueGetFunc();
                    },
                    set: function (newValue) {
                        svalueSetFunc(newValue);
                    }
                });
            }
        }
        // vm.model = newValue;
        if (schema.validFunc) {
            Object.defineProperty(obj, '$isFuncValid', {
                enumerable: false,
                get: function () {
                    return vm.validFunc;
                }
            });
        }
        // console.log("after create vm "+propName);
        /*
        if (schema.summary) {
          // if (vm.summary !== parent[propName]) {
          vm.$options.$ext.$model[propName] = vm.summary;
          // }
          vm.$watch('summary', (newValue: any) => {
            // console.log('summary watch');
    
            vm.$options.$ext.$model[propName] = newValue;
          });
        }
        */
        if (!self.options.disableCalculations) {
            if (schema.calc) {
                // if (vm.calc !== vm.$options.$ext.$model[propName]) {
                // console.log('calc set watcher');
                if (computedOnly) {
                    vm.value = vm.calc;
                    vm.$watch('calc', function (newValue) {
                        // console.log('zmiana wartości computed', propName, newValue);
                        vm.value = newValue;
                    });
                }
                else {
                    if (schema.type === 'array' || schema.type === 'object') {
                        if (vm.calc !== undefined) {
                            obj.$setData(vm.calc, undefined, true);
                        }
                        // vm.$set(parent, propName, vm.calc);
                        // vm.$options.$ext.$model[propName] = vm.calc;
                        // }
                        vm.$watch('calc', function (newValue) {
                            if (!dirty && (self.options.dirtyOnBlur || self.options.dirtyOnInput)) {
                                dirty = true;
                            }
                            if (newValue !== undefined) {
                                obj.$setData(newValue, undefined, true);
                            }
                        });
                    }
                    else {
                        if (vm.calc !== undefined) {
                            Vue.set(parent, propName, vm.calc);
                        }
                        // vm.$set(parent, propName, vm.calc);
                        // vm.$options.$ext.$model[propName] = vm.calc;
                        // }
                        vm.$watch('calc', function (newValue) {
                            if (!dirty && (self.options.dirtyOnBlur || self.options.dirtyOnInput)) {
                                dirty = true;
                            }
                            if (newValue !== undefined) {
                                Vue.set(parent, propName, newValue);
                            }
                        });
                    }
                }
            }
            if (schema.aggregate && !schema.aggregate.delay) {
                if (Array.isArray(schema.aggregate.property)) {
                    var mparent_3 = parent[propName];
                    // const mparent = vm.$options.$ext.$model[propName];
                    var res_1 = vm.aggregate;
                    schema.aggregate.property.forEach(function (x) { return (mparent_3[x] = res_1[x]); });
                    vm.$watch('aggregate', function (newValue) {
                        var mparent2 = parent[propName];
                        // const mparent2 = vm.$options.$ext.$model[propName];
                        for (var key in newValue) {
                            if (newValue.hasOwnProperty(key)) {
                                mparent2[key] = newValue[key];
                            }
                        }
                    });
                }
                else {
                    if (computedOnly) {
                        vm.value = vm.aggregate;
                        vm.$watch('aggregate', function (newValue) {
                            vm.value = newValue;
                        });
                    }
                    else {
                        if (schema.type === 'array' || schema.type === 'object') {
                            obj.$setData(vm.aggregate, undefined, true);
                            // vm.$set(parent, propName, vm.calc);
                            // vm.$options.$ext.$model[propName] = vm.calc;
                            // }
                            vm.$watch('aggregate', function (newValue) {
                                if (!dirty && (self.options.dirtyOnBlur || self.options.dirtyOnInput)) {
                                    dirty = true;
                                }
                                Vue.set(parent, propName, newValue);
                                obj.$setData(newValue, undefined, true);
                            });
                        }
                        else {
                            Vue.set(parent, propName, vm.aggregate);
                            // Vue.set(vm.$options.$ext.$model, propName, vm.aggregate);
                            // vm.$options.$ext.$parentmodel[propName] = vm.aggregate;
                            vm.$watch('aggregate', function (newValue) {
                                if (!dirty && (self.options.dirtyOnBlur || self.options.dirtyOnInput)) {
                                    dirty = true;
                                }
                                Vue.set(parent, propName, newValue);
                                // Vue.set(vm.$options.$ext.$model, propName, newValue);
                                // vm.$options.$ext.$parentmodel[propName] = newValue;
                            });
                        }
                    }
                }
            }
        }
        // let vmsg =
        var rules = {};
        // obj.$parent = dest;
        // obj.$schema = schema;
        // obj.key = vm.model["key"];
        // obj.key = propName;
        // let obj = reactivedata;
        // obj.validation = {
        // };
        var savedValue;
        var alreadyVelidate = false;
        if (schema.type === 'array') {
            Object.defineProperties(obj, {
                $items: {
                    enumerable: true,
                    get: function () {
                        // console.log('get $items');
                        return vm.items;
                    }
                },
                $error: {
                    enumerable: true,
                    get: function () {
                        if (dirty && !alreadyVelidate) {
                            obj.$validate();
                            alreadyVelidate = true;
                        }
                        // if (self.form.currentSection !== formSection) {
                        //  formSection = self.form.currentSection;
                        // }
                        return vm.error;
                    }
                }
            });
        }
        else {
            Object.defineProperties(obj, {
                $error: {
                    enumerable: true,
                    get: function () {
                        // formSection = self.form.currentSection;
                        // console.log('section', obj.$path, formSection);
                        return vm.error;
                    }
                }
            });
        }
        Object.defineProperties(obj, {
            $path: {
                enumerable: true,
                configurable: true,
                get: function () {
                    return this.$isRoot ? '' : path(this);
                }
            },
            /*
            $stringValue: {
              enumerable: false,
              get() {
                return vm.stringValue;
              },
              set(newValue) {
                vm.stringValue = newValue;
              }
            },
            $isEmpty: {
              enumerable: false,
              get() {
                // let nvalue = parent[propName];
                const nvalue = this.$stringValue;
                console.log('read isEmpty', nvalue, nvalue == null || nvalue === '');
                return nvalue === null || nvalue === '';
                // return vm.isEmpty
              }
            },
            */
            $hasFocus: {
                enumerable: false,
                get: function () {
                    return vm.focused;
                },
                set: function (newValue) {
                    // console.log('$hasFocus', this.$path, newValue, vm.focused);
                    if (newValue) {
                        vm.focused = true;
                        if (self.options.resetOnFocus) {
                            obj.$reset();
                        }
                    }
                    else {
                        // if (vm.focused) {
                        if (true) {
                            if (typeok) {
                                vm.stringValue = null;
                            }
                            vm.focused = false;
                            // console.log('$hasFocus', this.$path, newValue, dirty, self.dirtyOnBlur);
                            if (!dirty && self.options.dirtyOnBlur) {
                                // dirty = true;
                                // console.log('validate on blur', obj.$validate());
                                obj.$validate();
                            }
                        }
                    }
                }
            },
            $formSection: {
                enumerable: false,
                get: function () {
                    return formSection;
                },
                set: function (newValue) {
                    if (newValue !== formSection) {
                        formSection = newValue;
                        // console.log('set section', this.$path, newValue);
                    }
                }
            },
            $dirty: {
                enumerable: false,
                get: function () {
                    return dirty;
                },
                set: function (newValue) {
                    dirty = newValue;
                    if (obj.$isRoot) {
                        self.options.startDirty = newValue;
                    }
                }
            }
            /*
            obj.$destroy = () => {
              vm.$destroy();
            };
            */
        });
        /*
            if (required) {
                Object.defineProperty(obj,"$isRequired",{
                    enumerable: false,
                    value: true
    
                })
    
            }
            */
        /*
    
            Object.defineProperty(obj.$validation, "$errors", {
                enumerable: false,
                get() {
                    return vm.validation.errors;
                }
    
    
            });
            Object.defineProperty(obj.$validation, "$valid", {
                enumerable: false,
                get() {
                    //return vm.validation.errors.length==0;
                    return vm.$valid;
                }
    
    
            });
            */
        /*
            Object.defineProperty(obj, "$parentmodel", {
                enumerable: false,
                get() { return parent }
            });
            */
        /*
                        const getterDefs = buildFromKeys(getterNames, (key) => ({
                      enumerable: true,
                      configurable: true,
                      get: () => this[key]
                    }))
            */
        /*
                    Object.defineProperty(obj.validation, "$isDirty", {
                        enumerable: false,
                        configurable: true,
                        get() { return vm.$isDirty }
                    });
            */
        // let stringValue = null;
        if (self.form) {
            Object.defineProperty(obj, '$form', {
                enumerable: false,
                get: function () {
                    return self.form;
                }
            });
        }
        return obj;
    };
    SchemaWrapper.prototype.wrap = function (parent, schema, propName) {
        // console.log('wrap');
        this.clear();
        // napraw schema, rozwią refs i dodaj $parent
        var stime = new Date().getTime();
        // console.log('fixSchema', new Date().getTime() - stime);
        // czy schema było naprawioane czy nie
        if (Array.isArray(schema)) {
            schema = JSchema_1.fixAndMergeSchema(schema);
        }
        else if (schema.$parent === undefined) {
            schema = JSchema_1.fixAndMergeSchema([schema]);
        }
        // this.calcFunctions = [];
        // this.summaryFunctions = [];
        this.vueInstances = [];
        var mainprop;
        if (propName) {
            if (parent[propName].__ob__ === undefined && this.Vue) {
                this.Vue.observable(parent.propName);
            }
            mainprop = this.wrapProperty(null, parent, propName, schema);
        }
        else {
            var data = { model: parent };
            if (data.model.__ob__ === undefined && this.Vue) {
                this.Vue.observable(data.model);
            }
            mainprop = this.wrapProperty(null, data, 'model', schema);
        }
        Object.defineProperty(mainprop, '$isRoot', {
            enumerable: false,
            get: function () {
                return true;
            }
        });
        var self = this;
        // this.runCalc();
        return mainprop;
    };
    SchemaWrapper.defaultOptions = {
        startDirty: false,
        dirtyOnBlur: true,
        dirtyOnInput: false,
        resetOnFocus: false,
        disableCalculations: false,
        disableValidations: false,
        wrapAll: false
    };
    return SchemaWrapper;
}());
exports.SchemaWrapper = SchemaWrapper;
exports.default = SchemaWrapper;
//# sourceMappingURL=SchemaWrapper.js.map